<template>
    <div :class="{'bodyfixed':ismodalshow,'bodyauto':!ismodalshow}">
        <div class="menu_top padding_bottom_64">
            <div class="padding-32">
                <div class="order_menu">
                    <div v-if="currentlang !=='eng'" class="inline-block order_tab" :class="{'active':currenttap == item.type}" v-for="(item,index) in rankArr" @click="tapchoose(item)">
                        <span class="vertical-middle" :class="{'tapactivecolor':currenttap == item.type}">{{item.title}}</span>
                    </div>
                    <div v-if="currentlang =='eng'" class="inline-block order_tab" :class="{'active':currenttap == item.type}" v-for="(item,index) in rankArren" @click="tapchoose(item)">
                        <span class="vertical-middle" :class="{'tapactivecolor':currenttap == item.type}">{{item.title}}</span>
                    </div>
                </div>
            </div>
            <div v-show="currenttap == 'myreport'">
                <div class="position_relative report_Item" style="height: 400px;margin-bottom: 24px;"  v-for="item in boughtlist" @click="toreportdetail(item)">
                    <div class="rank_reportL">
                        <div class="reportL_label">{{typedesc[item.type]}}{{$t('index.reportTitle')}}</div>
                        <div class="display_flex flex-direction_column justify-content_flex-justify report_left_height">
                            <div>
                                <div class="title_limit2 line2">{{item.title}}</div>
                                <div class="report_content">{{item.summary}}</div>
                            </div>
                            <div class="more_report">{{$t('rankindex.lookreport')}}</div>
                        </div>
                    </div>
                    <div class="rank_report" :style="{backgroundImage:'url('+ item.listImageLargePc +')'}"></div>
                </div>
                <div class="more border" style="margin: 20px auto 0px;" @click="more()" v-if="totalpage > 1"> {{$t('index.morereport')}} </div>
                <div v-if="empty" class="default_none">{{$t('common.returnmessage.noboughtreport')}}</div>
                <div v-if="nologin" class="more" style="margin:32px auto 0;border: 1px solid #E9E9EB;" @click="login()">
                        {{$t('common.returnmessage.loginnow')}}
                    </div>
                <!-- <div v-if="nologin" class="default_none">{{$t('common.returnmessage.nologin')}}</div> -->
                <div>
                    <div class="suggesttitle">{{$t('product.suggest_report')}}</div>
                    <div class="index-swpier">
                        <swiper ref="suggest_report_Swiper" :options="swiperOptions2">
                            <swiper-slide v-for="(item,index) in suggestreportdata" :key="index" >
                                <div class="position_relative report_Item" style="height: 400px;margin-bottom: 24px;" @click="todetail('report',item)">
                                    <div class="rank_reportL">
                                        <div class="reportL_label">{{typedesc[item.type]}}{{$t('index.reportTitle')}}</div>
                                        <div class="display_flex flex-direction_column justify-content_flex-justify report_left_height">
                                            <div>
                                                <div class="title_limit2 line2">{{item.title}}</div>
                                                <div class="report_content">{{item.summary}}</div>
                                            </div>
                                            <div class="more_report">{{$t('rankindex.lookreport')}}</div>
                                        </div>
                                    </div>
                                    <div class="rank_report" :style="{backgroundImage:'url('+ item.listImageLargePC +')'}">
                                        <div class="label_bought" :class="{'free':item.isFree,'bought':item.buyStatus}" v-if="item.buyStatus || item.isFree == '0'">{{item.buyStatus?langdesc.bought:(item.isFree=='0'?langdesc.lang:'')}}</div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination2" slot="pagination" style="padding-top:35px;"></div>
                        </swiper>
                    </div>
                    <div class="more" style="margin:32px auto 0;border: 1px solid #E9E9EB;" @click="gorouter('/reportlist?type=report')">
                        {{$t('index.morereport')}}
                    </div>
                </div>
            </div>
            <div v-show="currenttap == 'myrank'">
                <div style="padding-bottom:40px;">
                    <div class="position_relative display_flex   flex-wrap_wrap">
                        <div class="rankitem" v-for="item in boughtlist" @click="torankdetail(item)">
                            <div class="coveritem" :style="{backgroundImage: 'url(' +  item.listImage+ ')'}">
                            </div>
                            <div class="sec_name">{{item.title}}</div>
                            <div class="date display_flex justify-content_flex-justify  align-items_center">
                                <div >{{formatTimefun(item.publishTime)}}</div>
                                <span class="arr_class"></span>
                            </div>
                        </div>
                    </div>
                    <div class="more border" style="margin: 20px auto 0px;" @click="more()" v-if="totalpage > 1"> {{$t('index.morelist')}}</div>
                    <div v-if="empty" class="default_none">{{$t('common.returnmessage.noboughtrank')}}</div>
                    <!-- <div v-if="nologin" class="default_none">{{$t('common.returnmessage.nologin')}}</div> -->
                    <!-- <div v-if="nologin" class="default_none"></div> -->
                    <div v-if="nologin" class="more" style="margin:32px auto 0;border: 1px solid #E9E9EB;" @click="login()">
                        {{$t('common.returnmessage.loginnow')}}
                    </div>
                </div>
                <div>
                    <div class="suggesttitle">{{$t('product.suggest_rank')}}</div>
                    <div class="index-swpier">
                        <swiper ref="suggest_rank_Swiper" :options="swiperOptions1">
                            <swiper-slide v-for="(item,index) in suggestrankdata" :key="index" >
                                <div class="rankitem" @click="todetail('rank',item)">
                                    <div class="coveritem" :style="{backgroundImage: 'url(' +  item.listImage+ ')'}">
                                        <div class="label_bought" :class="{'free':item.isFree,'bought':item.buyStatus}" v-if="item.buyStatus || item.isFree == '0'">{{item.buyStatus?langdesc.bought:(item.isFree=='0'?langdesc.lang:'')}}</div>
                                    </div>
                                    <div class="sec_name">{{item.title}}</div>
                                    <div class="date display_flex justify-content_flex-justify align-items_center">
                                        <div>{{formatTimefun(item.publishTime)}}</div>
                                        <span class="arr_class"></span>
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination1" slot="pagination" style="padding-top:35px;"></div>
                        </swiper>
                    </div>
                    <div class="more" style="margin:32px auto 0;border: 1px solid #E9E9EB;" @click="gorouter('/reportlist?type=rank')">
                        {{$t('index.morelist')}}
                    </div>
                </div>
                
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}

.order_menu {
    background: #F8FBFD;
    height: 64px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #60DEB4;
    text-align: left;
    .order_tab {
        width: 160px;
        height: 60px;
        color: #A8A8AD;
        line-height: 60px;
        cursor: pointer;
        border-top: 4px solid #F8FBFD;
        text-align: center;

        &.active {
            background: #fff;
            border-top: 4px solid #60DEB4;
        }

    }
}


.suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding-top: 40px;
    padding-bottom: 32px;
    margin-bottom: 32px;
    border-bottom: 2px solid #F8FBFD;

}

.more {
    width: 246px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    letter-spacing: 4px;
    cursor: pointer;
    background: url('../../assets/images/arr.png') no-repeat 210px 20px;
    background-color: #FFFFFF;
    &.border{
        border: 1px solid #E9E9EB;
    }
    &:hover{
            color: #fff;
            background: url('https://p1.fishqc.net/FlRbIiMKiKzC7ci97sZYFJ284KUS') no-repeat 210px 20px;
            background-color: #60DEB4;
        }
}

.default_none{
    padding:60px 0;
    box-sizing: border-box;
    font-size:22px;
    color: #A8A8AD;
}


</style>
<style type="text/css" lang="scss">
/* 轮播图 */
.swiper-container {
    width: 100%;
    height: 100%;
}

// .swiper-wrapper{
//  height: 430px;
// }
.swiper-slide {
    background-position: center;
    background-size: cover;

}

.index-swpier {
    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background: #E5E5E5;
        border-radius: 4px;

        &.swiper-pagination-bullet-active {
            width: 16px;
            height: 8px;
            background: #76E2D2;
            border-radius: 4px;
        }
    }

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
        text-align: center;
    }
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { buylistApi,suggestrankApi,suggestreportApi } from '@/api/api.js'
import { myMixin } from '@/mixin/mixin.js'
import {formatTime} from '@/utils/other.js'
import Modal from '@/components/Modal.vue'
import { getCookie } from '@/utils/cookieUtil'
export default {
    name: '',
    components: {  
        banner,
        modal:Modal
    },
    mixins: [myMixin],
    data() {
        return {
            rankArr: [{
                    title: this.$t('personal.myrank'),
                    type: 'myrank',
                    typNum:'1',
                    icon: '',
                    iconActive: ''
                },
                {
                    title: this.$t('personal.myreport'),
                    type: 'myreport',
                    typNum:'2',
                    icon: '',
                    iconActive: ''
                },


            ],
            rankArren: [{
                    title: this.$t('personal.myrank'),
                    type: 'myrank',
                    typNum:'1',
                    icon: '',
                    iconActive: ''
                }


            ],
            currenttap: 'myrank',
            swiperOptions1: {   //榜单轮播
                pagination: {
                    el: '.swiper-pagination1'
                },
                slidesPerGroup : 3,
                slidesPerView : 4,
                uniqueNavElements: false,
                autoplay:true,
                observer:true,
                observerParents:true,
                // Some Swiper option/callback...
            },
            swiperOptions2: {  //报告轮播
                pagination: {
                    el: '.swiper-pagination2'
                },
                // slidesPerGroup : 3,
                // slidesPerView : 1,
                uniqueNavElements: false,
                collectflag:false,
                autoplay:true,
                observer:true,
                observerParents:true,
            },
            currentpage:1,
            boughtlist:[],
            data_end_flag:false,
            totalpage:1,
            empty:false,
            nologin:false,
            suggestreportdata:[],    //推荐报告
            suggestrankdata:[],       //推荐榜单
            ismodalshow:false,
            langdesc:{
                bought:this.$t('rankindex.bought'),
                free:this.$t('index.free')
            },
            currentlang:''
        }
    },
    computed: {
        swiperRank() {
            return this.$refs.suggest_rank_Swiper.$swiper
        },
        swiperReport() {
            return this.$refs.suggest_report_Swiper.$swiper
        },
        formatTimefun(){
            return function(ctime){
                return formatTime(ctime,'Y-M-D')
            }
        }
    },
    mounted() {
        this.currentlang = window.localStorage.getItem("LOCALE")
        this.mylist('1')
        this.suggestrank()
        this.suggestreport()

    },
    methods: {
        tapchoose(item) {
            // 类型，1榜单，2报告
            this.currenttap = item.type 
            
            this.nologin = false
            this.empty = false
            this.data_end_flag = false
            this.currentpage = 1
            this.boughtlist = []
            this.mylist(item.typNum)
            if(item.typNum == '2'){
                this.suggestreport()
            }else{
                this.suggestrank()
            }
        },
        mylist(type){
            if(this.data_end_flag){
                return
            }
            buylistApi({
                prdType:type,
                page: this.currentpage, 
                limit:30,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.boughtlist = this.boughtlist.concat(res.data.prdList) 
                    this.totalpage = res.data.totalpage
                    if(this.currentpage >= res.data.totalpage){
                        this.data_end_flag = true;
                    }
                    
                }else if(res.code == 401){
                    this.nologin = true
                    // this.gorouter('/login?region=0')
                }else if(res.code == 204){
                    this.empty = true
                }else {
                    this.toast(res.message)
                    

                }
            })
        },
        more(){
            if(this.currentpage > this.total){
                return false
            }else{
                this.currentpage ++ //显示条数新增
                this.mylist(this.currenttap) //请求列表list 接口方法
            }
        },
        // 推荐的榜单
        suggestrank(){
            var that = this;
            suggestrankApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                limit:12,
                device:1
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.suggestrankdata = res.data.list 
                    that.$nextTick(()=>{
                        that.$refs.suggest_rank_Swiper.$swiper.update()
                        that.$refs.suggest_rank_Swiper.$swiper.autoplay.start()
                    })
                    
                }
            })
        },
        // 推荐的报告
        suggestreport(){
            var that = this;
            suggestreportApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                limit:9,
                device:1
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.suggestreportdata = res.data.list 
                    that.$nextTick(()=>{
                        that.$refs.suggest_report_Swiper.$swiper.update()
                        that.$refs.suggest_report_Swiper.$swiper.autoplay.start()
                    })
                    // this.swiperReport.update()
                }
            }) 
        },
        torankdetail(item){

            if(item.urlPc){
                window.location.href = item.urlPc
                    
            }else{
                this.gorouter('/rank/detail/'+item.prdId)
            }
            
        },
        toreportdetail(item){
            this.gorouter('/report/detail/'+item.prdId)
        },
        todetail(type,item){
            console.log(type,item)
            switch(type){
                case  'report':
                    if(item.buyStatus){  //已购买状态，进入详情
                        this.gorouter('/report/detail/'+item.reportUnionId)
                    }else{   //弹出导购弹窗，有previewVideo，弹窗视频导购，否则图片导购
                        this.ismodalshow = true
                        this.$refs.modaltoast.show({
                            type:'guide',  //弹窗类型，guide:导购页
                            itemtype:'2',    //报告
                            itemdata:item
                        });
                    }
                break;
                case  'rank':
                    // if(item.buyStatus){  //已购买榜单，进入详情
                    //     if(item.urlPc){
                    //         window.location.href = item.urlPc
                                
                    //     }else{
                    //         this.gorouter('/rank/detail/'+item.rankingUnionId)
                    //     }
                    // }else{
                    //     this.ismodalshow = true
                    //     this.$refs.modaltoast.show({
                    //         type:'guide',
                    //         itemtype:'1',    //榜单
                    //         itemdata:item
                    //     });
                    // }
                    if(getCookie('fqcU')){
                        if(item.buyStatus){  //已购买榜单，进入详情
                            if(item.rankingType == '3'){
                                if(item.urlPc){
                                    window.location.href = item.urlPc
                                }
                            }else{
                                this.gorouter('/rank/detail/'+item.rankingUnionId)
                            }
                        }else{
                            this.ismodalshow = true
                            this.$refs.modaltoast.show({
                                type:'guide',
                                itemtype:'1',    //榜单
                                itemdata:item
                            });
                        }
                    }else{ //未登录
                        if(item.rankingType == '3'){ //专题榜单
                            if(item.urlPc){
                                window.location.href = item.urlPc
                            }
                        }else{   // 非专题榜单

                            if(item.buyStatus){  //已购买榜单，进入详情
                                this.gorouter('/rank/detail/'+item.rankingUnionId)
                            }else{
                                this.ismodalshow = true
                                this.$refs.modaltoast.show({
                                    type:'guide',
                                    itemtype:'1',    //榜单
                                    itemdata:item
                                });
                            }
                        }
                    }
                break;
            }
        },
        getmaterial(e){
            console.log('回调弹窗关闭状态',e)
            this.ismodalshow = e.showstatus
        },
        login(){
            var  returnURL = window.location.href
            this.gorouter('/login?region=0'+'&returnURL='+returnURL)
        }

    }
}
</script>